import React, { useCallback, useEffect, useState } from 'react';
import notaEntradaMapeamentosApi from '../../services/api/notaEntradaMapeamentosApi';
import MapeamentoItem from './MapeamentoItem';
import './NotaEntradaView.css';

const NotaEntradaView = ({ nota, onSelectMapeamento, onBack }) => {
  const [mapeamentos, setMapeamentos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isIniciando, setIsIniciando] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  const loadMapeamentos = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await notaEntradaMapeamentosApi.listMapeamentosByNota(
        nota.tenantId,
        nota.idEntrada
      );
      setMapeamentos(response.items || []);
    } catch (err) {
      console.error('Erro ao carregar mapeamentos da nota:', err);
      setError('Erro ao carregar histórico de mapeamentos');
    } finally {
      setIsLoading(false);
    }
  }, [nota.tenantId, nota.idEntrada]);

  useEffect(() => {
    loadMapeamentos();
  }, [loadMapeamentos]);

  const handleIniciarMapeamento = async () => {
    try {
      setIsIniciando(true);
      setError(null);
      setSuccessMsg(null);
      await notaEntradaMapeamentosApi.iniciarMapeamento(String(nota.tenantId), nota.idEntrada);
      setSuccessMsg('Mapeamento iniciado com sucesso');
      await loadMapeamentos();
    } catch (err) {
      console.error('Erro ao iniciar mapeamento:', err);
      setError(`Erro ao iniciar mapeamento: ${err.response?.data?.error || err.message || 'Erro desconhecido'}`);
    } finally {
      setIsIniciando(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const formatCurrency = (value) => {
    if (!value) return '-';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  return (
    <div className="nota-entrada-view">
      <div className="nota-view-header">
        <button className="btn-back" onClick={onBack}>
          ← Notas de Entrada
        </button>
        <div className="nota-view-info">
          <div className="nota-view-title">
            <h3>Nota #{nota.idEntrada}</h3>
            <span className="nota-view-tenant">Empresa {nota.tenantId}</span>
          </div>
          <div className="nota-view-meta">
            <div className="nota-view-meta-item">
              <span className="meta-label">Fornecedor</span>
              <span className="meta-value">{nota.nomeCliente || '-'}</span>
            </div>
            <div className="nota-view-meta-item">
              <span className="meta-label">Data</span>
              <span className="meta-value">{formatDate(nota.dataPedido)}</span>
            </div>
            <div className="nota-view-meta-item">
              <span className="meta-label">Valor Total</span>
              <span className="meta-value">{formatCurrency(nota.valorTotalNota)}</span>
            </div>
            <div className="nota-view-meta-item">
              <span className="meta-label">Status</span>
              <span className="meta-value">{nota.statusPedido || '-'}</span>
            </div>
          </div>
        </div>
        <button
          className="btn btn-primary btn-iniciar-mapeamento"
          onClick={handleIniciarMapeamento}
          disabled={isIniciando}
        >
          {isIniciando ? 'Iniciando...' : 'Mapear'}
        </button>
      </div>

      {successMsg && (
        <div className="nota-view-success">{successMsg}</div>
      )}

      {error && (
        <div className="nota-view-error">{error}</div>
      )}

      <div className="nota-view-body">
        <div className="historico-header">
          <h4>Histórico de Mapeamentos</h4>
          <button className="btn-refresh" onClick={loadMapeamentos} disabled={isLoading}>
            Atualizar
          </button>
        </div>

        {isLoading ? (
          <div className="historico-loading">
            <div className="loading-spinner"></div>
            <p>Carregando...</p>
          </div>
        ) : mapeamentos.length === 0 ? (
          <div className="historico-empty">
            <div className="empty-icon">📋</div>
            <p>Nenhum mapeamento realizado ainda</p>
            <span>Clique em "Mapear" para iniciar</span>
          </div>
        ) : (
          <div className="historico-list">
            {mapeamentos.map((m) => (
              <MapeamentoItem
                key={m.id}
                mapeamento={m}
                isSelected={false}
                onSelect={onSelectMapeamento}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotaEntradaView;
